module.exports = __webpack_public_path__ + "06f6ca031c54ac8bc812fdf796a7ebd3.png";